import React from "react";
import help from "../../../img/undraw_financial_data_re_p0fl.svg";
import "./adminmanage.css";
import { Fade } from "react-awesome-reveal";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
// import "./adminmanage.css";
import { useState } from "react";
import { Container, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  CreateUserDashboardAction,
  GetClaimsAction,
  GetRolesAction,
  GetUsersAction,
  UpdateUserdashboardAction,
} from "../../../redux/actions/ManageAdminAction";
import notify from "../../Notifcation";
import { ToastContainer } from "react-toastify";
const Adminmanage = () => {
  const [TypeAdmin, setTypeAdmin] = useState("");
  const [Name, setName] = useState("");
  const [isedit, setIsedit] = useState(false);
  const [userId, setuserId] = useState("");
  const [IsActive, setIsActive] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [Passwordp, setPasswordp] = useState("password");
  const [foc, setfoc] = useState(false);
  const [Passwordc, setPasswordc] = useState("password");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordconfirmInput, setpasswordconfirmInput] = useState("");
  const dispatch = useDispatch();
  const {
    GetRolesAccount,
    GetUsersAccounts,
    GetClaimsAccounts,
    CreateUserDashboardAccounts,
    UpdateUserdash,
  } = useSelector((state) => state.ManageAdminR);
  const [ClimsChecked, setClimsChecked] = useState([]);
  const [Adminsta, setAdminsta] = useState(false);
  useEffect(() => {
    dispatch(GetUsersAction());
    dispatch(GetRolesAction());
    dispatch(GetClaimsAction());
  }, []);
  useEffect(() => {
    if (TypeAdmin === "Admin") {
      setAdminsta(false);
    } else if (TypeAdmin === "Editor") {
      setAdminsta(true);
    }
  }, [TypeAdmin]);
  const togglep = () => {
    if (Passwordp === "password") {
      setPasswordp("text");
      return;
    }
    setPasswordp("password");
  };
  const togglec = () => {
    if (Passwordc === "password") {
      setPasswordc("text");
      return;
    }
    setPasswordc("password");
  };

  const updata = async () => {
    if (Name === null || Phone === "" || TypeAdmin === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (Phone.length < 11 || Phone.length > 14) {
      notify("يجب ادخال رقم هاتف صحيح", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateUserdashboardAction({
        userId: userId,
        name: Name,
        email: Email,
        newRoleName: TypeAdmin,
        isAccountActive: IsActive,
        newPassword: passwordInput === "" ? null : passwordInput,
        claims: ClimsChecked,
      })
    );
    setLoading(false);
    setIsPress(false);
    setIsedit(false);
    setName("");
    setEmail("");
    setPhone("");
    setpasswordconfirmInput("");
    setPasswordInput("");
    setTypeAdmin("");
    setClimsChecked([]);
  };

  const updateitem = (item, idx) => {
    setfoc(true);
    setIsedit(true);
    setPasswordInput("");
    setpasswordconfirmInput("");
    setuserId(item.id);
    setName(item.name);
    setIsActive(item.isAccountActive);
    setEmail(item.email);
    setPhone(item.phoneNumber);
    setTypeAdmin(
      item.roleName === "Admin"
        ? "Admin"
        : item.roleName === "Editor"
        ? "Editor"
        : null
    );
    setClimsChecked(item.claims);
  };
  const handleChange = (event) => {
    setTypeAdmin(event.target.value);
  };
  const tryChangePhone = (e) => {
    if (isedit) {
      notify("غير مسموح بتغير رقم الهاتف", "warn");
      return;
    } else {
      setPhone(e.target.value);
    }
  };
  const addNewItem = async (e) => {
    e.preventDefault();
    if (
      Name === null ||
      Phone === "" ||
      passwordInput === "" ||
      passwordconfirmInput === "" ||
      TypeAdmin === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (Phone.length < 11 || Phone.length > 14) {
      notify("يجب ادخال رقم هاتف صحيح", "error");
      return;
    }
    if (passwordInput !== passwordconfirmInput) {
      notify("يجب ان تكون كلمة السر متطابقة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      CreateUserDashboardAction({
        name: Name,
        phoneNumber: Phone,
        email: Email,
        password: passwordInput,
        roleName: TypeAdmin,
        claims: ClimsChecked,
      })
    );

    setLoading(false);
    setIsPress(false);

    setName("");
    setEmail("");
    setPhone("");
    setpasswordconfirmInput("");
    setPasswordInput("");
    setTypeAdmin("");
    setClimsChecked([]);
  };
  const clickCategory = (e) => {
    let value = e.target.value;
    if (e.target.checked === true) {
      setClimsChecked([
        ...ClimsChecked,
        { claimName: value, isSelected: true },
      ]);
    } else if (e.target.checked === false) {
      const newArry = ClimsChecked.filter((e) => e.claimName !== value);
      setClimsChecked(newArry);
    }
  };

  useEffect(() => {
    if (loading === false) {
      if (CreateUserDashboardAccounts) {
        if (
          CreateUserDashboardAccounts.data.responseMessage ===
          "This phone number is already exist"
        ) {
          notify("هذا الرقم مسجل من قبل", "error");
        } else if (
          CreateUserDashboardAccounts.data.responseMessage ===
          "User Added Succesfully"
        ) {
          notify("تم اضافة الحساب بنجاح", "success");
          dispatch(GetUsersAction());
          dispatch(GetClaimsAction());
          dispatch(GetRolesAction());
        }
      }
      if (UpdateUserdash) {
        if (
          UpdateUserdash.data.responseMessage ===
          "This phone number is already exist"
        ) {
          notify("هذا الرقم مسجل من قبل", "error");
          dispatch(GetRolesAction());
          dispatch(GetClaimsAction());
        } else if (
          UpdateUserdash.data.responseMessage ===
          "User claims updated successfully"
        ) {
          notify("تم تعديل الحساب بنجاح", "success");
          dispatch(GetUsersAction());
          dispatch(GetClaimsAction());
          dispatch(GetRolesAction());
        }
      }
    }
  }, [loading]);
  return (
    <>
      <Container>
        <div className="mmain">
          <div className="inputs-container w-5p flex-column">
            <div className="inp-container w-400">
              <h3 className="mb-4 mt-5">إدارة الأدمن</h3>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اسم المستخدم
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                focused={foc}
                value={Name}
                onChange={(e) => setName(e.target.value)}
                inputProps={{ maxLength: 120 }}
                type="text"
              />
            </div>
            <div className="inp-container w-400">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    رقم الهاتف
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                value={Phone}
                onChange={tryChangePhone}
                inputProps={{ maxLength: 15 }}
                type="number"
              />
            </div>
            <div className="inp-container w-400">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    البريد الألكتروني
                    <span style={{ color: "red", fontSize: "11px" }}>
                      (أختياري)
                    </span>
                  </Typography>
                }
                focused={foc}
                type="email"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                variant="outlined"
                className="em"
              />
            </div>
            <div className="inp-container w-400">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    كلمة المرور
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type={Passwordp}
                value={passwordInput}
                focused={foc}
                onChange={(e) => {
                  setPasswordInput(e.target.value);
                }}
                inputProps={{ maxLength: 120 }}
              />

              <button className="btn btn-primary e" onClick={togglep}>
                {Passwordp === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
            </div>
            <div className="inp-container w-400">
              {" "}
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    تأكيد كلمة المرور
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type={Passwordc}
                focused={foc}
                value={passwordconfirmInput}
                inputProps={{ maxLength: 15 }}
                onChange={(e) => {
                  setpasswordconfirmInput(e.target.value);
                }}
              />
              <button className="btn btn-primary c" onClick={togglec}>
                {Passwordc === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
            </div>
            <div className="inp-container w-400">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    صلاحية الأدمن
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={TypeAdmin}
                  focused={foc}
                  onChange={handleChange}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      صلاحية الأدمن
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  }>
                  {GetRolesAccount
                    ? GetRolesAccount.map((item, idx) => {
                        return (
                          <MenuItem key={idx} value={item.name}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </Select>
              </FormControl>
            </div>
            {Adminsta && (
              <div className="col-md-12">
                {" "}
                <div className="row">
                  {GetClaimsAccounts
                    ? GetClaimsAccounts.map((item, index) => {
                        return (
                          <div className="col-md-4" key={index}>
                            <div className="input-check">
                              {" "}
                              {item.name}
                              <input
                                type="checkbox"
                                checked={ClimsChecked.find(
                                  (itemm) => itemm.claimName === item.name
                                )}
                                value={item.name}
                                onChange={clickCategory}
                              />
                            </div>
                          </div>
                        );
                      })
                    : null}{" "}
                  <div className="col-md-4"></div>
                </div>
              </div>
            )}
            {isedit ? (
              <div className="input-check">
                {" "}
                مفعل
                <input
                  type="checkbox"
                  checked={IsActive ? true : false}
                  value={IsActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                />
              </div>
            ) : null}

            <div className="mb-5 text-center">
              {isedit ? (
                isPress && loading ? (
                  <button className=" buttonadd" style={{ height: "52px" }}>
                    {" "}
                    <Spinner animation="border" role="status"></Spinner>
                  </button>
                ) : (
                  <button
                    className=" buttonadd"
                    style={{ height: "52px" }}
                    onClick={updata}>
                    {" "}
                    تعديل
                  </button>
                )
              ) : isPress && loading ? (
                <button className=" buttonadd" style={{ height: "52px" }}>
                  <Spinner animation="border" role="status"></Spinner>
                </button>
              ) : (
                <button
                  className="buttonadd "
                  style={{ height: "52px" }}
                  onClick={addNewItem}>
                  إضافة
                </button>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <Fade direction="left">
              <div className="p-3 py-5">
                <Fade direction="right">
                  <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                    <img
                      className="mt-5"
                      width="150px"
                      src={help}
                      alt="avatar"
                    />
                  </div>
                </Fade>
              </div>
            </Fade>
          </div>
        </div>
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                تاريخ الإنشاء<i className="fa-solid fa-calendar-days"></i>
              </th>
              <th>
                اسم المستخدم<i className="fa-solid fa-layer-group"></i>
              </th>
              <th>
                رقم الهاتف<i className="fa-solid fa-user"></i>
              </th>
              <th>
                البريد الألكتروني<i className="fa-solid fa-user-group"></i>
              </th>
              <th>
                صلاحيات الأدمن <i className="fa-solid fa-file-import"></i>
              </th>
              <th>حالة الحساب</th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {GetUsersAccounts && GetUsersAccounts.length > 0
              ? GetUsersAccounts.map((item, idx) => {
                  const date = new Date(item.createdDate);
                  return (
                    <tr key={idx} onDoubleClick={() => updateitem(item)}>
                      <td>{date.toLocaleDateString("en-GB")}</td>
                      <td>{item.name}</td>
                      <td>{item.phoneNumber}</td>
                      <td>{item.email === "string" ? null : item.email}</td>
                      <td>{item.roleName}</td>
                      <td>{item.isAccountActive ? "مفعل" : "غير مفعل"}</td>
                      <td className="icon-w">
                        <i
                          onClick={() => updateitem(item)}
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "rgb(0 44 146)" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
          <ToastContainer autoClose={1200} />
        </Table>
      </Container>
    </>
  );
};

export default Adminmanage;
